import React from 'react';

interface PaginationProps {
  pagination: {
    page: number;
    pages: number;
    total: number;
    hasNext: boolean;
    hasPrev: boolean;
  } | null;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({ pagination, onPageChange, disabled = false }) => {
  if (!pagination || pagination.pages <= 1) return null;
  
  return (
    <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4">
      <button 
        disabled={disabled || !pagination.hasPrev}
        onClick={() => onPageChange(pagination.page - 1)}
        className="px-3 py-2 sm:px-4 sm:py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium transition-colors"
      >
        Previous
      </button>
      
      <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-2 text-sm text-gray-600">
        <span className="font-medium">
          Page {pagination.page} of {pagination.pages}
        </span>
        <span className="hidden sm:inline">•</span>
        <span className="text-xs sm:text-sm">
          {pagination.total.toLocaleString()} total items
        </span>
      </div>
      
      <button 
        disabled={disabled || !pagination.hasNext}
        onClick={() => onPageChange(pagination.page + 1)}
        className="px-3 py-2 sm:px-4 sm:py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium transition-colors"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
